export interface ProductEdition {
  id: string;
  title: string;
  description?: string | null;
  priceStars: number;
  compareAtStars?: number | null;
  priceRub?: number | null;
  compareAtRub?: number | null;
}

export function selectedEdition(
  product: { editions?: ProductEdition[] | null },
  editionId?: string | null,
): ProductEdition | null {
  const editions = product.editions ?? [];
  if (editions.length === 0) return null;
  return editions.find((item) => item.id === editionId) ?? editions[0] ?? null;
}

export function pricedFrom(
  product: {
    priceStars: number;
    priceRub?: number | null;
    compareAtStars?: number | null;
    compareAtRub?: number | null;
  },
  edition: ProductEdition | null,
) {
  if (!edition) {
    return {
      priceStars: product.priceStars,
      priceRub: product.priceRub ?? null,
      compareAtStars: product.compareAtStars ?? null,
      compareAtRub: product.compareAtRub ?? null,
    };
  }

  return {
    priceStars: edition.priceStars,
    priceRub: edition.priceRub ?? null,
    compareAtStars: edition.compareAtStars ?? null,
    compareAtRub: edition.compareAtRub ?? null,
  };
}

export function isGamesCategory(category?: { slug?: string | null; title?: string | null } | null): boolean {
  const slug = category?.slug ?? '';
  const title = category?.title ?? '';
  return slug === 'games' || slug.includes('game') || /игр/i.test(title);
}
